var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { formatCurrency, services } from '../../../../shared';
import React, { useState, useEffect } from 'react';
import { Button, Grid, Heading, Icon, InputCheckbox } from '../../../shared';
import './add-fees.scss';
import { WorldPay } from '../../worldpay/worldpay';
export var FeeType;
(function (FeeType) {
    FeeType[FeeType["AddToLoan"] = 0] = "AddToLoan";
    FeeType[FeeType["PayableNow"] = 1] = "PayableNow";
    FeeType[FeeType["PayOnApplication"] = 2] = "PayOnApplication";
})(FeeType || (FeeType = {}));
export var AddFees = function (_a) {
    var caseId = _a.caseId, form = _a.form, feeData = _a.feeData, heading = _a.heading, noRowsMessage = _a.noRowsMessage, feeType = _a.feeType, reloadGrids = _a.reloadGrids, allowPayNow = _a.allowPayNow, noPayNowDescription = _a.noPayNowDescription;
    var _b = useState([]), feesToAdd = _b[0], setFeesToAdd = _b[1];
    var _c = useState([]), fees = _c[0], setFees = _c[1];
    var _d = useState(), modalVisible = _d[0], setModalVisible = _d[1];
    var _e = useState(), inputLoanAmount = _e[0], setInputLoanAmount = _e[1];
    var _f = useState(false), exceedsMaximumFeeLimit = _f[0], setExceedsMaximumFeeLimit = _f[1];
    var _g = useState({}), checkedFees = _g[0], setCheckedFees = _g[1];
    var _h = useState([]), remainingFees = _h[0], setRemainingFees = _h[1];
    var checkboxes = document.querySelectorAll('input[type="checkbox"]');
    var disabledIds = [];
    var columns = [
        {
            id: 'name',
            description: 'Fee Name',
        },
        {
            id: 'amount',
            description: 'Fee Amount',
            render: function (column, row) {
                return React.createElement("span", null,
                    "\u00A3",
                    formatCurrency(row[column.id]));
            },
        },
        {
            id: 'selected',
            description: 'Select',
            sort: false,
            render: function (column, row) {
                var _a, _b;
                if (feeType === FeeType.AddToLoan && row[column.id] == true)
                    return React.createElement(Icon, { name: "tick", colour: "primary" });
                else if ((feeType === FeeType.PayableNow || feeType === FeeType.PayOnApplication) &&
                    ((_a = row['isPaid']) !== null && _a !== void 0 ? _a : false) == true)
                    return React.createElement(Icon, { name: "tick" });
                else
                    return (React.createElement(InputCheckbox, { id: "checkbox-".concat(row['loanToValueFeeId']), dataValue: row['loanToValueFeeId'], onToggle: submit, checked: (_b = checkedFees[row['loanToValueFeeId']]) !== null && _b !== void 0 ? _b : false }));
            },
        },
        {
            id: 'remove',
            description: 'Remove',
            sort: false,
            hidden: feeType === FeeType.PayableNow,
            render: function (_column, row) {
                var _a;
                return (React.createElement(Button, { type: "button", variant: "bare", disabled: (feeType === FeeType.AddToLoan && !row['selected']) ||
                        (feeType === FeeType.PayOnApplication && !((_a = row['isPaid']) !== null && _a !== void 0 ? _a : false)), dataValue: row['loanToValueFeeId'], onClick: feeType === FeeType.PayOnApplication ? removePaidIllustrationOnly : remove },
                    React.createElement(Icon, { name: "close", colour: "primary" })));
            },
        },
    ];
    checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            var checkboxId = this.getAttribute('data-value');
            checkboxes.forEach(function (checkbox) {
                if (checkbox.getAttribute('data-value') === checkboxId && !checkbox.checked) {
                    checkbox.disabled = true;
                }
                else if (checkbox.getAttribute('data-value') === checkboxId && checkbox.checked) {
                    checkbox.disabled = false;
                }
            });
        });
        checkbox.addEventListener('change', function () {
            var checkboxId = this.getAttribute('data-value');
            var isChecked = this.checked;
            if (!isChecked) {
                checkboxes.forEach(function (checkbox) {
                    if (checkbox.getAttribute('data-value') === checkboxId) {
                        checkbox.disabled = false;
                    }
                });
            }
        });
    });
    // This is used for all fees except paid fees on illustration
    var remove = function (e) {
        var _a;
        var feeId = Number((_a = e.currentTarget.getAttribute('data-value')) !== null && _a !== void 0 ? _a : '0');
        var addedFee = fees.find(function (fee) { return fee.loanToValueFeeId === feeId; });
        var selectedFees = fees.filter(function (fee) { return checkedFees[fee.loanToValueFeeId]; });
        var remainingFees = fees.filter(function (fee) { return !checkedFees[fee.loanToValueFeeId]; });
        var updatedCheckedFees = __assign({}, checkedFees);
        selectedFees.forEach(function (fee) { return delete updatedCheckedFees[fee.loanToValueFeeId]; });
        setCheckedFees(updatedCheckedFees);
        setRemainingFees(remainingFees);
        if (addedFee && addedFee.feeId != null)
            services.removeFee(caseId, form === null || form === void 0 ? void 0 : form.formId, addedFee.loanToValueFeeId).finally(function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    console.log(feesToAdd.length);
                    if (feesToAdd.length == 0) {
                        setFeesToAdd([]);
                    }
                    reloadGrids(caseId, form === null || form === void 0 ? void 0 : form.formId);
                    return [2 /*return*/];
                });
            }); });
    };
    // This call can only be used on illustration
    var removePaidIllustrationOnly = function (e) {
        var _a, _b;
        var feeId = Number((_a = e.currentTarget.getAttribute('data-value')) !== null && _a !== void 0 ? _a : '0');
        var addedFee = fees.find(function (fee) { return fee.loanToValueFeeId === feeId; });
        var selectedFees = fees.filter(function (fee) { return checkedFees[fee.loanToValueFeeId]; });
        var remainingFees = fees.filter(function (fee) { return !checkedFees[fee.loanToValueFeeId]; });
        var updatedCheckedFees = __assign({}, checkedFees);
        selectedFees.forEach(function (fee) { return delete updatedCheckedFees[fee.loanToValueFeeId]; });
        setCheckedFees(updatedCheckedFees);
        setRemainingFees(remainingFees);
        if (addedFee && addedFee.feeId != null)
            services.removePaidFee(caseId, form === null || form === void 0 ? void 0 : form.formId, addedFee.feeId, (_b = addedFee.productId) !== null && _b !== void 0 ? _b : 0).finally(function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (feesToAdd.length == 0) {
                        setFeesToAdd([]);
                    }
                    reloadGrids(caseId, form === null || form === void 0 ? void 0 : form.formId);
                    return [2 /*return*/];
                });
            }); });
    };
    var submit = function (e) {
        var _a;
        var _b;
        var feeId = Number((_b = e.currentTarget.getAttribute('data-value')) !== null && _b !== void 0 ? _b : '0');
        var addedFee = fees.find(function (fee) { return fee.loanToValueFeeId === feeId; });
        var feeToAddIndex = feesToAdd.findIndex(function (fee) { return fee.loanToValueFeeId === feeId; });
        var currentList = __spreadArray([], (feesToAdd || []), true);
        setCheckedFees(__assign(__assign({}, checkedFees), (_a = {}, _a[feeId] = !checkedFees[feeId], _a)));
        if (feeToAddIndex < 0) {
            currentList.push(addedFee);
        }
        else {
            currentList.splice(feeToAddIndex, 1);
        }
        setFeesToAdd(currentList);
        setExceedsMaximumFeeLimit((currentList.length > 0 &&
            Number(formatFees(currentList, true).toString().replace(',', '')) + inputLoanAmount >
                Number(addedFee.maxLoanAmount)) ||
            formatFees(currentList, true) > addedFee.maximumAddableFee);
    };
    var saveFees = function () {
        if (feesToAdd.length > 0)
            services.saveFee(caseId, form === null || form === void 0 ? void 0 : form.formId, feesToAdd).finally(function () { return __awaiter(void 0, void 0, void 0, function () {
                var checkboxes;
                return __generator(this, function (_a) {
                    setFeesToAdd([]);
                    reloadGrids(caseId, form === null || form === void 0 ? void 0 : form.formId);
                    checkboxes = document.querySelectorAll('input[type="checkbox"]');
                    checkboxes.forEach(function (checkbox) {
                        var checkboxId = checkbox.getAttribute('data-value');
                        console.log('disabledIds_indexOf', disabledIds.indexOf(checkboxId));
                        if (feesToAdd.some(function (fee) { return fee.loanToValueFeeId === Number(checkboxId); })) {
                            if (disabledIds.indexOf(checkboxId) < 0) {
                                checkbox.disabled = false;
                            }
                        }
                    });
                    return [2 /*return*/];
                });
            }); });
    };
    // This call can only be used on Illustration
    var saveIllustrationOnlyFees = function () {
        if (feesToAdd.length > 0)
            services.savePaidFees(caseId, form === null || form === void 0 ? void 0 : form.formId, feesToAdd).finally(function () { return __awaiter(void 0, void 0, void 0, function () {
                var checkboxes;
                return __generator(this, function (_a) {
                    setFeesToAdd([]);
                    reloadGrids(caseId, form === null || form === void 0 ? void 0 : form.formId);
                    checkboxes = document.querySelectorAll('input[type="checkbox"]');
                    checkboxes.forEach(function (checkbox) {
                        var checkboxId = checkbox.getAttribute('data-value');
                        console.log('disabledIds_indexOf', disabledIds.indexOf(checkboxId));
                        if (feesToAdd.some(function (fee) { return fee.loanToValueFeeId === Number(checkboxId); })) {
                            if (disabledIds.indexOf(checkboxId) < 0) {
                                checkbox.disabled = false;
                            }
                        }
                    });
                    return [2 /*return*/];
                });
            }); });
    };
    var hideModal = function () {
        setModalVisible(false);
        setFeesToAdd([]);
    };
    var showModal = function () {
        setModalVisible(true);
    };
    var formatFees = function (feeOptions, all) {
        if (feeOptions && feeOptions.length < 1)
            return 0;
        if (feeType === FeeType.AddToLoan)
            return formatCurrency(feeOptions === null || feeOptions === void 0 ? void 0 : feeOptions.map(function (fee) { return (fee.selected || all ? fee.amount : 0); }).reduce(function (prev, next) { return (prev !== null && prev !== void 0 ? prev : 0) + next; }));
        if (feeType === FeeType.PayableNow || feeType === FeeType.PayOnApplication)
            return formatCurrency(feeOptions === null || feeOptions === void 0 ? void 0 : feeOptions.map(function (fee) { return (fee.isPaid ? fee.amount : 0); }).reduce(function (prev, next) { return (prev !== null && prev !== void 0 ? prev : 0) + next; }));
    };
    var fetchLoanData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var caseDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getCaseDetails(caseId)];
                case 1:
                    caseDetails = (_a.sent()).data;
                    setInputLoanAmount(Number(caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.find(function (val) { return val.code === 'LOANAMOUNT'; }).value));
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        setFees(feeData !== null && feeData !== void 0 ? feeData : []);
    }, [caseId, form, feeType, feeData, remainingFees]);
    useEffect(function () {
        fetchLoanData();
    }, [caseId]);
    return (React.createElement("div", { className: "u-mb-2 c-add-fee" },
        feesToAdd && feeType === FeeType.PayableNow && (React.createElement(WorldPay, { fees: feesToAdd, show: modalVisible, handleClose: hideModal, reloadGrids: reloadGrids, caseId: caseId, formId: form === null || form === void 0 ? void 0 : form.formId })),
        React.createElement("div", { className: "u-mb-2" },
            React.createElement(Heading, { level: "h3", title: heading, mb: 4 }),
            React.createElement(Grid, { rowData: fees, columns: columns, noRowsMessage: noRowsMessage })),
        feeType === FeeType.AddToLoan && (React.createElement("div", { className: "c-add-fee__summary" },
            exceedsMaximumFeeLimit ? (React.createElement("p", null, " You\u2018ve exceeded the amount that can be added to a loan ")) : (React.createElement("b", null,
                "Fees you have added to the loan: \u00A3",
                formatFees(fees))),
            (fees === null || fees === void 0 ? void 0 : fees.find(function (fee) { return fee.selected === false; })) ? (React.createElement(Button, { variant: "primary", type: "button", onClick: saveFees, childClasses: "u-ml-2", disabled: exceedsMaximumFeeLimit || feesToAdd.length < 1 }, "Add Fees to Loan")) : undefined)),
        (feeType === FeeType.PayableNow || feeType === FeeType.PayOnApplication) && (React.createElement("div", { className: "c-add-fee__summary" },
            React.createElement("b", null,
                "Fees that you ",
                feeType === FeeType.PayOnApplication ? 'will ' : '',
                "have paid: \u00A3",
                formatFees(fees)),
            !allowPayNow && feeType === FeeType.PayableNow ? (React.createElement("p", { className: "warning-text" }, noPayNowDescription)) : undefined,
            allowPayNow && (React.createElement(Button, { variant: "primary", type: "button", onClick: showModal, childClasses: "u-ml-2", disabled: (feesToAdd === null || feesToAdd === void 0 ? void 0 : feesToAdd.length) < 1 }, "Pay Now")),
            feeType === FeeType.PayOnApplication && (React.createElement(Button, { variant: "primary", type: "button", childClasses: "u-ml-2", onClick: saveIllustrationOnlyFees, disabled: (feesToAdd === null || feesToAdd === void 0 ? void 0 : feesToAdd.length) < 1 }, "Pay on application/completion"))))));
};
